import { VerticalFlex } from '@eversports/react-components/primitives/Flex'
import { makeStyles } from '@mui/styles'
import { usePyroField } from 'pyro-form'
import React, { ReactElement } from 'react'

import { AddressProps } from '../registration-context'

import AutoCompleteAddress from './AutoCompleteAddress'
import ManualAddress from './ManualAddress'

const useStyles = makeStyles({
  mainContainer: {
    gap: '16px', // default spacing
  },
})

interface Props {
  autoCompleteSearchValue?: string
  autoCompleteLabel?: string | ReactElement<any>
  onChange: (
    name: Extract<keyof AddressProps, string>,
    value: AddressProps[Extract<keyof AddressProps, string>],
  ) => void
}

const Address: React.FC<React.PropsWithChildren<Props>> = ({
  autoCompleteSearchValue,
  autoCompleteLabel,
  onChange,
}) => {
  const classes = useStyles()
  const {
    core: { onBlur: onStreetNumberBlur },
  } = usePyroField<AddressProps, 'streetNumber'>('streetNumber')

  const handleChange = (values: AddressProps) => {
    onChange('street', values.street)
    onChange('streetNumber', values.streetNumber)
    onChange('zip', values.zip)
    onChange('city', values.city)
    onChange('country', values.country)
    onChange('latitude', values.latitude)
    onChange('longitude', values.longitude)
    // Mark the street number as touched so a missing house number error is shown right after selecting a Google suggestion
    onStreetNumberBlur()
  }

  return (
    <VerticalFlex className={classes.mainContainer}>
      <AutoCompleteAddress
        name="address"
        label={autoCompleteLabel}
        onChange={handleChange}
        searchValue={autoCompleteSearchValue}
      />
      <ManualAddress />
    </VerticalFlex>
  )
}

export default Address
